// store.js
import { reactive } from 'vue';

export const settings = reactive({
  navTheme: 'light', // light
  headerTheme: 'black',
  toolsLeftShow: false,
  layout: 'mix', // side top mix
  menuRender: true,
  title: 'Gattaran',
  defaultSideMenuSelect: '',
  defaultHeaderMenuSelect: '',
  itemWidth: 100,
});
